import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TosNoticeComponent } from './tos-notice.component';

@NgModule({
  declarations: [TosNoticeComponent],
  imports: [CommonModule],
  exports: [TosNoticeComponent],
})
export class TosNoticeModule {}
